
    import Vue from "vue";

    const END_POINT = "/studentRequirement";

    const getStudentRequirement = id => Vue.axios.get(END_POINT + "/" + id);

    const getAllStudentRequirements = data => Vue.axios.get(END_POINT, {params: data});

    const createStudentRequirement = studentRequirement => Vue.axios.post(END_POINT,  studentRequirement );

    const createAllStudentRequirements = StudentRequirements => Vue.axios.post(END_POINT + "/all",  StudentRequirements );

    const updateStudentRequirement = studentRequirement => Vue.axios.put(END_POINT  + "/" + studentRequirement.id,  studentRequirement );

    const deleteStudentRequirement = id => Vue.axios.delete(END_POINT  + "/" + id);

    export {
      getStudentRequirement,
      getAllStudentRequirements,
      createStudentRequirement,
      createAllStudentRequirements,
      updateStudentRequirement,
      deleteStudentRequirement
    };
    